import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

//---Services
import { StorageService } from '../services/storage/storage.service';

//---Models
import { User } from '../models/user/user';

@Injectable({
  providedIn: 'root'
})
export class FrontAuthGuard {
  private storageService = inject(StorageService);
  private router = inject(Router);


  private user: User | undefined;

  canActivate(): boolean {
    this.user = this.storageService.getUser();

    if (!this.user) {
      this.router.navigate(['/authentication/login']);
      return false;
    }

    if (this.user.roles?.includes('ROLE_ADMIN')) {
      this.router.navigate(['/admin']);
      return false;
    }
    
    return true;
  }
}